import { render, staticRenderFns } from "./ContactSection.vue?vue&type=template&id=0f85d06f&scoped=true&"
import script from "./ContactSection.vue?vue&type=script&lang=js&"
export * from "./ContactSection.vue?vue&type=script&lang=js&"
import style0 from "./ContactSection.vue?vue&type=style&index=0&id=0f85d06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f85d06f",
  null
  
)

export default component.exports